import type { TeamGroupRowResponse, TeamGroupUpsertRequest } from "libs/apiClient";

export function buildTeamGroupUpsertPayload(teamGroup: TeamGroupRowResponse): TeamGroupUpsertRequest {
	return {
		name: teamGroup.name,
		notes: teamGroup.notes ?? null,
		teamIds: (teamGroup.teams ?? []).map((team) => team.id),
		clubIds: (teamGroup.clubs ?? []).map((club) => club.id),
		scoutVisibility: teamGroup.scoutVisibility,
		sharedAnalysis: teamGroup.sharedAnalysis,
		visibleTeamsheets: teamGroup.visibleTeamsheets,
	};
}

export function isTeamDirectlyInTeamGroup(teamGroup: TeamGroupRowResponse, teamId: number): boolean {
	return (teamGroup.teams ?? []).some((team) => team.id === teamId);
}

export function isClubDirectlyInTeamGroup(teamGroup: TeamGroupRowResponse, clubId: number): boolean {
	return (teamGroup.clubs ?? []).some((club) => club.id === clubId);
}

export function canRemoveEntityFromTeamGroup(
	teamGroup: TeamGroupRowResponse,
	entity: { teamId: number; clubId?: never } | { clubId: number; teamId?: never },
): boolean {
	if (entity.teamId !== undefined) {
		return isTeamDirectlyInTeamGroup(teamGroup, entity.teamId);
	}

	return isClubDirectlyInTeamGroup(teamGroup, entity.clubId);
}
